import styled from "styled-components";

import { ScrollableTabsStyledProps as Props } from "./ScrollableTabs.types";

const ScrollableTabsStyled = styled.div<Props>`
  display: flex;

  .ScrollableTabs {
    &__item {
      margin-right: 2.4rem;
      cursor: pointer;

      &__icon {
        justify-content: center;
        align-items: center;
        padding-right: 0.8rem;
      }

      &__label {
        color: var(--palette-white);
        font-size: 2rem;
        line-height: 2.4rem;

        &__container {
          align-items: center;
        }
      }

      &__marker {
        height: 0.2rem;
        background-color: var(--palette-white);
        width: 100%;
        margin-top: 0.8rem;
      }
    }
  }
`;

export default ScrollableTabsStyled;
